import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { LightMode, DarkMode, SettingsBrightness, Check } from "@mui/icons-material";
import { useColorMode } from "../../contexts/ColorModeContext";

// Three choices (System / Light / Dark) rather than a plain two-state
// switch — "System" has to stay reachable as its own option, not just the
// implicit result of toggling off a manual choice, since that's the
// default behavior the app is required to offer.
const OPTIONS = [
  { value: null, label: "System", icon: <SettingsBrightness fontSize="small" /> },
  { value: "light", label: "Light", icon: <LightMode fontSize="small" /> },
  { value: "dark", label: "Dark", icon: <DarkMode fontSize="small" /> },
];

// Drop-in icon button for an AppBar/Toolbar — shows the resolved mode's
// icon (sun/moon), opens a small menu to pick System/Light/Dark. Used by
// AdminLayout, CustomerLayout, RiderLayout, and AuthLayout so the control
// looks and behaves identically everywhere in the app.
const ColorModeToggle = ({ sx }) => {
  const { mode, override, setOverride } = useColorMode();
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Tooltip title="Theme">
        <IconButton
          size="small"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ color: "text.secondary", ...sx }}
        >
          {mode === "dark" ? <DarkMode fontSize="small" /> : <LightMode fontSize="small" />}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {OPTIONS.map((opt) => (
          <MenuItem
            key={opt.label}
            selected={override === opt.value}
            onClick={() => {
              setOverride(opt.value);
              setAnchorEl(null);
            }}
            sx={{ fontSize: 13, minWidth: 160 }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>{opt.icon}</ListItemIcon>
            <ListItemText>{opt.label}</ListItemText>
            {override === opt.value && (
              <Check fontSize="small" sx={{ ml: 1.5, color: "primary.main" }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ColorModeToggle;
